var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.533 1.1953L6.94141 1.19568L7.05249 9.8034L11.6441 9.80303L11.533 1.1953Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22879 5.51794C7.20614 3.7672 7.97715 2.21433 9.1801 1.20949C8.27701 0.47879 7.14325 0.0373591 5.91265 0.0374273C2.99731 0.037589 0.670375 2.48876 0.70956 5.5183C0.748746 8.54785 3.13909 10.9988 6.05443 10.9986C7.28503 10.9985 8.40736 10.557 9.29156 9.82618C8.06281 8.8367 7.25143 7.26869 7.22879 5.51794Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8749 5.48058C17.9141 8.51013 15.5871 10.9613 12.6718 10.9615C11.4412 10.9615 10.3074 10.5201 9.40434 9.78943C10.6219 8.78458 11.3783 7.2317 11.3557 5.48096C11.333 3.73022 10.5218 2.17743 9.29287 1.17273C10.1771 0.44193 11.2994 0.0003715 12.53 0.000300416C15.4453 0.000132015 17.8359 2.46626 17.8749 5.48058Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMastercard);
export default __webpack_public_path__ + "static/media/icon_mastercard.a65987d56b3663579e29dfa9848baf33.svg";
export { ForwardRef as ReactComponent };